<template lang="pug">
.v-price-ranger.price-ranger(v-if="field")
	button.price-ranger__btn(type="button" @click="open = !open" :disabled="field.disabled")
		span.price-ranger__btn-text(v-if="computedText" key="text") {{computedText}}
		span.price-ranger__btn-placeholder(v-else="field.placeholder") {{field.placeholder}}
		v-svg-icon.price-ranger__btn-icon(icon="chevron-down-sm" :class="{'rotate-180': open}")
	transition(name="fade" mode="out-in")
		.price-ranger__list(v-if="open")
			.price-ranger__dropdown
				v-field.price-ranger__field(:field="field" v-model="localValue" @update:model-value="handleInput")
				button.btn.btn--primary.price-ranger__mobile-apply(
					v-if="field.mobileApplyText && isSm"
					type="button"
					@click="applyAndClose") {{ field.mobileApplyText }}

</template>

<script>
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [isMobMixin],
	props: {
		field: {
			type: Object,
			default: null,
		},

		modelValue: {
			type: [Object, String, Number],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: {},
			open: false,
		};
	},

	created() {
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEsc);
	},

	unmounted() {
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('keydown', this.handleEsc);
	},

	methods: {
		applyAndClose() {
			// Range inputs debounce their regular update. Emit the current object here so
			// a quick tap on Search immediately after "Next" cannot use stale values.
			this.$emit('update:model-value', this.localValue);
			this.open = false;
		},

		dataHandler(value) {
			this.localValue = value;
		},

		handleInput(value) {
			this.localValue = value;
			this.$emit('update:model-value', this.localValue);
		},

		handleClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.open = false;
			}
		},

		handleEsc(e) {
			if (e.keyCode === 27 && this.open) {
				e.stopPropagation();
				this.open = false;
			}
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

	},

	watch: {
		modelValue: {
			immediate: true,
			handler() {
				this.updateLocalValue();
			}
		},
	},

	computed: {
		computedText() {
			if(typeof this.localValue.min === 'number' && this.localValue.max) {
				return `${this.field.placeholderMin} ${this.field.prefixMin} ${this.localValue.min} ${this.field.postfixMin} - ${this.field.placeholderMax} ${this.field.prefixMax} ${this.localValue.max} ${this.field.postfixMax}`
			}

		}
	}
}
</script>
